import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a6a4fe20"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row mt-5 no-subscription-opacity" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "Installed Apps")
], -1))
const _hoisted_3 = {
  key: 0,
  class: "m-5 text-center"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fa fa-spin fa-spinner me-3" }, null, -1))
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Loading...")
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = {
  key: 0,
  class: "col-12 mb-3"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "text-muted" }, "You have no apps installed yet. Select an app below to install it.", -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = {
  key: 0,
  class: "modal show",
  tabindex: "-1",
  style: {"display":"block"}
}
const _hoisted_11 = { class: "modal-dialog" }
const _hoisted_12 = { class: "modal-content" }
const _hoisted_13 = { class: "modal-header" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "modal-title" }, "Remove app", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-body" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Are you sure you want to remove this app?")
], -1))
const _hoisted_16 = { class: "modal-footer" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-trash-alt fa-fixed me-2" }, null, -1))
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" Remove app ")
const _hoisted_19 = [
  _hoisted_17,
  _hoisted_18
]
const _hoisted_20 = {
  key: 1,
  class: "no-subscription-overlay"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "no-subscription-message" }, " No active subscription for the workspace. The installed apps are currently inactive. ", -1))
const _hoisted_22 = [
  _hoisted_21
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_tile = _resolveComponent("app-tile")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["container-fluid px-5", {'no-subscription': _ctx.showNoSubscriptionOverlay}]),
    style: {"flex":"1"}
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      (!_ctx.ready)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_6))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (_ctx.installedApps.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9))
              : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.installedApps, (app, appIdx) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "col-12 col-xl-6",
                    key: appIdx
                  }, [
                    _createVNode(_component_app_tile, {
                      appId: app.id,
                      name: app.app_name,
                      title: _ctx.availableApps[app.app_name].title,
                      icon: _ctx.availableApps[app.app_name].icon,
                      description: _ctx.availableApps[app.app_name].short_description,
                      state: app.authenticated ? '' : 'Unauthenticated',
                      "state-class": app.authenticated ? '' : 'bg-danger text-white',
                      labels: app.clients ? app.clients.map((c) => c.clientName) : [],
                      installed: app.subscribed,
                      "small-desc": _ctx.getSmallDesc(app),
                      onSettings: ($event: any) => (
                            _ctx.$router.push({
                                name: _ctx.getInstalledAppRouteName(app),
                                params: { appId: app.id },
                            })
                        ),
                      onInstall: ($event: any) => (
                            _ctx.$router.push({
                                name: app.authenticated ? _ctx.getInstalledAppRouteName(app) : _ctx.availableApps[app.app_name].install.route,
                                params: app.authenticated ? { appId: app.id } : Object.assign({ appId: app.id }, _ctx.availableApps[app.app_name].install.params),
                            })
                        ),
                      onOpen: ($event: any) => (
                            _ctx.$router.push({
                                name: app.authenticated ? _ctx.getInstalledAppRouteName(app) : _ctx.availableApps[app.app_name].install.route,
                                params: app.authenticated ? { appId: app.id } : Object.assign({ appId: app.id }, _ctx.availableApps[app.app_name].install.params),
                            })
                        ),
                      onDelete: ($event: any) => (_ctx.removeApp({ appId: app.id }))
                    }, null, 8, ["appId", "name", "title", "icon", "description", "state", "state-class", "labels", "installed", "small-desc", "onSettings", "onInstall", "onOpen", "onDelete"])
                  ]))
                }), 128))
          ], 64))
    ]),
    (_ctx.removeModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _createElementVNode("button", {
                  type: "button",
                  class: "btn-close",
                  "data-bs-dismiss": "modal",
                  "aria-label": "Close",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.removeModal = false))
                })
              ]),
              _hoisted_15,
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-secondary",
                  "data-bs-dismiss": "modal",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.removeModal = false))
                }, " Close "),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-danger",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.removeAppConfirm()))
                }, _hoisted_19)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showNoSubscriptionOverlay)
      ? (_openBlock(), _createElementBlock("div", _hoisted_20, _hoisted_22))
      : _createCommentVNode("", true)
  ], 2))
}